import React from 'react'
import { useSelector } from 'react-redux'

const Tabs = () => {
    const { tabs , selectedTab } = useSelector(state => state.newCompaign);

    return (
        <div>
            <div className='flex items-center flex-nowrap  mt-8  rounded-md gap-[1px] whitespace-nowrap overflow-x-auto'>
                {
                    tabs?.map(item => (
                        <div key={item?.id} 
                        className={`
                        ${item?.id === 1 ? 'rounded-tl-md rounded-bl-md' : ''}
                        ${item?.id === tabs?.length ? 'rounded-br-md rounded-tr-md' : ''}
                        ${selectedTab?.id === item?.id ? 'gradient-bg text-white' : 'bg-gray-200 text-dark'}
                        ${item.id === 3 ? 'flex-[1.2]' : 'flex-1'}
                        py-4 px-4 flex-1 text-sm text-center font-medium
                        `}>
                            <span>{item?.name}</span>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Tabs